import { accordionAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(
    accordionAnatomy.keys
);

const baseStyle = definePartsStyle({
    container: {
        border: 'none',
        borderTopWidth: 0,
        borderBottomWidth: 0,
        borderLeftWidth: 0,
        borderRightWidth: 0
    },
    button: {
        color: 'neutral.700',
        fontSize: 'sm',
        fontWeight: 'semibold',
        textTransform: 'uppercase',
        border: 'none',
        _hover: {
            background: 'transparent'
        }
    }
});

const createAccentVariant = (accentColor: string) =>
    definePartsStyle({
        container: {
            border: 'none',
            borderTopWidth: 0,
            borderBottomWidth: 0,
            borderLeftWidth: 0,
            borderRightWidth: 0
        },
        button: {
            paddingX: 0,
            paddingY: 1,
            borderBottomWidth: '2px',
            borderBottomStyle: 'solid',
            borderBottomColor: `accent.${accentColor}`,
            paddingBottom: 1
        },
        panel: {
            paddingX: 0
        }
    });

const variants = {
    spblue: createAccentVariant('spblue'),
    normalnavy: createAccentVariant('normalnavy'),
    darknavy: createAccentVariant('darknavy'),
    sandstone: createAccentVariant('sandstone'),
    goldenapricot: createAccentVariant('goldenapricot'),
    warmhoney: createAccentVariant('warmhoney'),
    softblush: createAccentVariant('softblush'),
    coral: createAccentVariant('coral'),
    clayrust: createAccentVariant('clayrust'),
    smokegrey: createAccentVariant('smokegrey'),
    lavender: createAccentVariant('lavender'),
    indigoslate: createAccentVariant('indigoslate'),
    moss: createAccentVariant('moss'),
    fern: createAccentVariant('fern')
};

export const accordionTheme = defineMultiStyleConfig({ baseStyle, variants });
